import React, { useState, useEffect } from "react";
import InputBox from "../../components/InputBox";
import { TextFieldValidator } from "../../components/InputBox/TextFieldValidator";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import { storeDefaultInformation } from "../../Store/TemplateStore/template.action";
import {
  Default_CIP_INFORMATION,
  PLANT_DETAILS,
} from "./defaultCIPInformationFields.config";
import { useTranslation } from "react-i18next";
import PopoverText from "../../components/PopoverText";
import InfoIconGreen from "../../assets/info-icon-green.svg";

const DefaultCIPInformation = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  React.useImperativeHandle(ref, () => ({ defaultInformation }));
  const temperature = useSelector((state) => state.temperature);
  const mass = useSelector((state) => state.mass);
  const cips = useSelector((state) => state.cips);

  const minTemp = temperature === "C" ? 0 : 32;
  const maxTemp = temperature === "C" ? 40 : 104;

  const defaultFields = Default_CIP_INFORMATION(minTemp, maxTemp);

  const defaultCIPState = useSelector((state) => ({
    design_bw_duration: state.design_bw_duration,
    design_duration_btw_bw: state.design_duration_btw_bw,

    acid_ceb_duration: state.acid_ceb_duration,
    acid_ceb_soak_duration: state.acid_ceb_soak_duration,
    acid_used_per_ceb: state.acid_used_per_ceb,
    acid_ceb_ph: state.acid_ceb_ph,
    acid_ceb_temp: state.acid_ceb_temp,
    alkali_ceb_duration: state.alkali_ceb_duration,
    alkali_ceb_soak_duration: state.alkali_ceb_soak_duration,
    alkali_used_per_ceb: state.alkali_used_per_ceb,
    alkali_ceb_ph: state.alkali_ceb_ph,
    alkali_ceb_temp: state.alkali_ceb_temp,

    acid_cip_duration: state.acid_cip_duration,
    acid_cip_soak_duration: state.acid_cip_soak_duration,
    acid_used_per_cip: state.acid_used_per_cip,
    acid_cip_ph: state.acid_cip_ph,
    acid_cip_temp: state.acid_cip_temp,
    alkali_cip_duration: state.alkali_cip_duration,
    alkali_cip_soak_duration: state.alkali_cip_soak_duration,
    alkali_used_per_cip: state.alkali_used_per_cip,
    alkali_cip_ph: state.alkali_cip_ph,
    alkali_cip_temp: state.alkali_cip_temp,
  }));

  const [errors, setErrors] = useState({
    design_bw_duration: null,
    design_duration_btw_bw: null,

    acid_ceb_duration: null,
    acid_ceb_soak_duration: null,
    acid_used_per_ceb: null,
    acid_ceb_ph: null,
    acid_ceb_temp: null,
    alkali_ceb_duration: null,
    alkali_ceb_soak_duration: null,
    alkali_used_per_ceb: null,
    alkali_ceb_ph: null,
    alkali_ceb_temp: null,

    acid_cip_duration: null,
    acid_cip_soak_duration: null,
    acid_used_per_cip: null,
    acid_cip_ph: null,
    acid_cip_temp: null,
    alkali_cip_duration: null,
    alkali_cip_soak_duration: null,
    alkali_used_per_cip: null,
    alkali_cip_ph: null,
    alkali_cip_temp: null,
  });

  const [noError, setNoError] = useState(true);

  useEffect(() => {
    const noError = Object.values(errors).every(
      (error) => error === "" || error === null
    );
    setNoError(noError);
    props.setNoDefaultError(noError);
  }, [errors]);

  // const updateTemperatureDefault = () => {
  //   const getDefaultTemperature = () => {
  //     return temperature === "C" ? 25 : 77;
  //   };
  //   dispatch(
  //     storeDefaultInformation({
  //       acid_cip_temp: getDefaultTemperature(),
  //       alkali_cip_temp: getDefaultTemperature(),
  //       cip_solution_temp: getDefaultTemperature(),
  //     })
  //   );
  // };

  useEffect(() => {
    if (cips === null) {
      // updateTemperatureDefault();
      setErrors({
        ...errors,
        acid_cip_temp: null,
        alkali_cip_temp: null,
        cip_solution_temp: null,
      });
    }
  }, [temperature, cips]);

  const defaultInformation = () => {
    if (noError) {
      const defaultInformation = {
        design_duration_btw_bw: defaultCIPState.design_duration_btw_bw,
        design_bw_duration: defaultCIPState.design_bw_duration,

        acid_ceb_duration: defaultCIPState.acid_ceb_duration,
        acid_ceb_soak_duration: defaultCIPState.acid_ceb_soak_duration,
        acid_used_per_ceb: defaultCIPState.acid_used_per_ceb,
        acid_ceb_ph: defaultCIPState.acid_ceb_ph,
        acid_ceb_temp: defaultCIPState.acid_ceb_temp,
        alkali_ceb_duration: defaultCIPState.alkali_ceb_duration,
        alkali_ceb_soak_duration: defaultCIPState.alkali_ceb_soak_duration,
        alkali_used_per_ceb: defaultCIPState.alkali_used_per_ceb,
        alkali_ceb_ph: defaultCIPState.alkali_ceb_ph,
        alkali_ceb_temp: defaultCIPState.alkali_ceb_temp,

        acid_cip_duration: defaultCIPState.acid_cip_duration,
        acid_cip_soak_duration: defaultCIPState.acid_cip_soak_duration,
        acid_used_per_cip: defaultCIPState.acid_used_per_cip,
        acid_cip_ph: defaultCIPState.acid_cip_ph,
        acid_cip_temp: defaultCIPState.acid_cip_temp,
        alkali_cip_duration: defaultCIPState.alkali_cip_duration,
        alkali_cip_soak_duration: defaultCIPState.alkali_cip_soak_duration,
        alkali_used_per_cip: defaultCIPState.alkali_used_per_cip,
        alkali_cip_ph: defaultCIPState.alkali_cip_ph,
        alkali_cip_temp: defaultCIPState.alkali_cip_temp,
      };
      dispatch(storeDefaultInformation(defaultInformation));
    } else {
      props.setActiveStep(0);
    }
  };

  const handleInputChange = (field, value, minValue, maxValue) => {
    dispatch(storeDefaultInformation({ [field]: value }));
    setErrors({ ...errors, [field]: null });

    const fieldName = t(`defaultInformationStrings.${field}`).split("(")[0];
    // Fields that should use mass unit
    const massUnitFields = [
      "alkali_used_per_cip",
      "acid_used_per_cip",
      "alkali_used_per_ceb",
      "acid_used_per_ceb",
    ];

    const addUnit = massUnitFields.includes(field);

    let adjMin = minValue;
    let adjMax = maxValue;
    if (addUnit && mass === "lb") {
      adjMin = minValue !== null ? +(minValue * 2.2).toFixed(2) : minValue;
      adjMax = maxValue !== null ? +(maxValue * 2.2).toFixed(2) : maxValue;
    }
    const minMsg = `${t("defaultInformationStrings.cannotLess")} ${adjMin}`;
    const rangeMsg = `${t(
      "defaultInformationStrings.cannotLess"
    )} ${adjMin} ${t("defaultInformationStrings.greaterThan")} ${adjMax}`;

    if ((value === "" && adjMin !== null) || parseFloat(value) < adjMin) {
      setErrors({
        ...errors,
        [field]: minMsg,
      });
    } else if (
      adjMax !== null &&
      (parseFloat(value) < adjMin || parseFloat(value) > adjMax)
    ) {
      setErrors({
        ...errors,
        [field]: rangeMsg,
      });
    }
  };

  const replaceUnit = (value) => {
    if (
      value.includes(t("defaultInformationStrings.acid_used_per_cip")) ||
      value.includes(t("defaultInformationStrings.alkali_used_per_cip")) ||
      value.includes(t("defaultInformationStrings.acid_used_per_ceb")) ||
      value.includes(t("defaultInformationStrings.alkali_used_per_ceb"))
    ) {
      value = value.replace("<unit>", mass);
    } else {
      value = value.replace("<unit>", `\u00B0${temperature}`);
    }
    return value;
  };
  return (
    <div className="lightGrayBorder section-container">
      <div className="headerTealText">
        <span>{t("defaultInformationStrings.defaultInformation")}</span>
        <PopoverText
          descriptor={<img src={InfoIconGreen} alt="icon" />}
          descriptionText={t(
            "defaultInformationStrings.defaultCIPInformationDescription"
          )}
        />
      </div>
      <div className="sub-grid-container ">
        {Object.keys(defaultFields).map((item) => (
          <div key={item} className="sub-section-container">
            <div className="default-grid-container">
              {Object.values(defaultFields[item]).map((field, index) => (
                <div className="sub-grid-item " key={index}>
                  <InputBox
                    value={defaultCIPState[field.key]}
                    name={field.key}
                    labelText={replaceUnit(
                      t(`defaultInformationStrings.${field.key}`)
                    )}
                    onChange={(value) =>
                      handleInputChange(
                        field.key,
                        value,
                        field.minValue,
                        field.maxValue
                      )
                    }
                    validator={TextFieldValidator.NUMBER_WITH_DECIMAL}
                    errorMsg={errors[field.key]}
                    maxLength={10}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

export default DefaultCIPInformation;
